import { IconMore } from "@icons/index";
import { useFocusActionClick } from "../hooks";
import { Dropdown, MenuProps } from "antd";
import classNames from "classnames";
import { Trans } from "react-i18next";
import { useState } from "react";
import { useAtomValue } from "jotai";
import { themeAtom } from "@src/jotai/theme";

interface FocusActionProps {
  className?: string;
  type: string;
  id: string | number | undefined;
  showReportIssus?: boolean;
  onReportIssue?: () => void;
}

const FocusAction = ({ className, id, type, showReportIssus = false, onReportIssue }: FocusActionProps) => {
  const { cancelFocus } = useFocusActionClick();
  const [open, setOpen] = useState(false);
  const theme = useAtomValue(themeAtom);
  const isDark = theme === "dark";

  const items: MenuProps["items"] = [
    ...(showReportIssus
      ? [
          {
            key: "report-issue",
            label: (
              <div
                className="w-full h-full flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  onReportIssue && onReportIssue();
                }}
              >
                <Trans>Report Issue</Trans>
              </div>
            ),
          },
        ]
      : []),
    {
      key: "cancelfocus",
      label: (
        <div
          className="w-full h-full flex items-center"
          onClick={(e) => {
            e.stopPropagation();
            cancelFocus?.(id as string, type);
          }}
        >
          <Trans>{type === "video-generation" ? "Delete" : "Unfollow"}</Trans>
        </div>
      ),
    },
  ];

  return (
    <Dropdown trigger={["hover"]} menu={{ items }} placement="bottomLeft" onOpenChange={setOpen}>
      <div
        className={classNames(
          "w-[24px] h-[24px] cursor-pointer flex items-center justify-center rounded-[4px]",
          isDark ? "bg-kds-mask" : "bg-[#22222240]",
          className,
          { "flex!": open },
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <IconMore className="w-[16px] h-[16px]" />
      </div>
    </Dropdown>
  );
};

export { FocusAction };
